module.exports = {
    "collectionLabel": `Javaslatok`
};


//# sourceMappingURL=hu-HU.main.js.map
